export default __webpack_public_path__ + "static/media/caffinated-coffee.ad370138.jpg";